import {
	FormContentSection,
	FormSectionCard,
	FormSectionTitle,
} from '../../Containers/PasserCommande/PasserCommande.styles'
import React, { useEffect } from 'react'
import { useState } from 'react'
import Modal from 'react-modal'
import { useForm, Controller } from 'react-hook-form'
import Flatpickr from 'react-flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import moment from 'moment'
import { CustomInput } from '../../Containers/RegisterTransporter/style'
import UploadFile from '../UploadSingleFile/upload.component'
import { BiEdit } from 'react-icons/bi'
import { MdDelete } from 'react-icons/md'
import { BASE_URL } from '../../api/base'
import {
	VEHICLE_TYPES,
	LIGHT_VEHICLES,
	HEAVY_VEHICLES,
	COMMON_OPTIONS,
	IMAGES,
} from '../../utils/vehicleData'
import { VehicleCard } from '../VehicleCard'
import { VehicleOptions } from '../VehicleOptions'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

// Define breakpoints for responsive design
const breakpoints = {
	mobile: '480px',
	tablet: '768px',
	laptop: '1024px',
}

const media = {
	mobile: `(max-width: ${breakpoints.mobile})`,
	tablet: `(max-width: ${breakpoints.tablet})`,
	laptop: `(max-width: ${breakpoints.laptop})`,
}

const HeaderContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;

	@media ${media.tablet} {
		flex-direction: column;
		align-items: flex-start;
	}
`

const HeaderInfo = styled.div`
	display: flex;
	flex-direction: column;
`

const AddVehicleButton = styled.button`
	background: #50f5a9;
	border: none;
	cursor: pointer;
	color: white;
	font-family: 'Montserrat';
	padding: 0 2rem;
	border-radius: 6px;
	font-weight: bold;
	height: 50px;

	@media ${media.tablet} {
		width: 100%;
		margin-top: 1rem;
	}
`

const TableContainer = styled.div`
	overflow-x: auto;
`

const ResponsiveTable = styled.table`
	width: 100%;
	text-align: left;
	border-radius: 20px;
	overflow: hidden;
	border: none;
	border-collapse: collapse;

	th,
	td {
		padding: 1rem;
	}

	thead tr {
		background-color: #f8f9fa;
	}

	tbody tr {
		background: white;
		&:nth-child(even) {
			background-color: #f2f2f2;
		}
	}
`

const ModalContent = styled.div`
	width: 100%;
	font-family: 'Montserrat';
	display: flex;
	flex-direction: column;
	font-size: 15px;
	text-align: left;
	color: #838eab;
`

const ModalTitle = styled.div`
	color: #51c7f2;
	font-size: 30px;
	margin-bottom: 1rem;
	font-weight: bold;
	font-family: 'Montserrat';
	text-align: center;
`

const FormGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;
	margin-bottom: 1rem;

	@media ${media.tablet} {
		grid-template-columns: 1fr;
	}
`

Modal.setAppElement('#root')

function AddVehicleRegister({
	onChange,
	initialVehicles = [],
	disableAdd = false,
	fileUrls = {},
}) {
	const [vehicles, setVehicles] = useState([])
	const [editIndex, setEditIndex] = useState(null)
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const {
		control,
		handleSubmit,
		register,
		reset,
		setValue,
		watch,
		formState: { errors },
	} = useForm({
		defaultValues: {
			type: '',
			date_mise_circulation: '',
			immatriculation: '',
			carte_grise: null,
			location: false,
		},
	})

	const handleSubmitForm = (data) => {
		let filteredData = { ...data }
		if (data.type === 'Véhicule léger') {
			filteredData = {
				type: data.type,
				date_mise_circulation: data.date_mise_circulation,
				immatriculation: data.immatriculation,
				location: data.location,
				carte_grise: data.carte_grise,
				options_vehicule_leger: data.options_vehicule_leger,
				vehicule_leger: data.vehicule_leger,
			}
		} else if (data.type === 'Poids lourds') {
			filteredData = {
				type: data.type,
				date_mise_circulation: data.date_mise_circulation,
				immatriculation: data.immatriculation,
				location: data.location,
				carte_grise: data.carte_grise,
				options_poids_lourds: data.options_poids_lourds,
				vehicule_poids_lourds: data.vehicule_poids_lourds,
			}
		}
		if (editIndex !== null) {
			const updatedVehicles = vehicles.map((v, index) =>
				index === editIndex ? data : v
			)
			setVehicles(updatedVehicles)
			onChange(updatedVehicles)
			setEditIndex(null)
		} else {
			setVehicles([...vehicles, filteredData])
			onChange([...vehicles, filteredData])
		}
		reset({
			type: '',
			date_mise_circulation: '',
			immatriculation: '',
			carte_grise: null,
			location: false,
		})
		setModalIsOpen(false)
	}

	const handleDelete = (index) => {
		const newVehicles = vehicles.filter((_, i) => i !== index)
		setVehicles(newVehicles)
		onChange(newVehicles)
	}

	const handleEdit = (index) => {
		const selectedVehicle = vehicles[index]
		reset(selectedVehicle)
		setModalIsOpen(true)
		setEditIndex(index)
	}

	const getVehicleOptions = () => {
		const type = watch('type')
		const vehicule_leger = watch('vehicule_leger')
		const vehicule_poids_lourds = watch('vehicule_poids_lourds')

		if (type === VEHICLE_TYPES.LIGHT) {
			if (
				['Break', 'Fourgon 12m³', 'Fourgon 14m³'].includes(
					vehicule_leger
				)
			) {
				return COMMON_OPTIONS
			}
			return [...COMMON_OPTIONS, 'Bachée']
		}

		if (type === VEHICLE_TYPES.HEAVY) {
			if (vehicule_poids_lourds === 'Tracteur') {
				return COMMON_OPTIONS
			}
			return [...COMMON_OPTIONS, 'Bachée']
		}

		return []
	}

	useEffect(() => {
		setVehicles(initialVehicles)
	}, [initialVehicles.length])

	useEffect(() => {
		if (watch('location')) {
			setValue('carte_grise', null)
		}
	}, [watch('location'), setValue])

	const type = watch('type')

	const handleOptionChange = (e) => {
		const selectedOption = e.target.value

		if (selectedOption === 'Bachée' || selectedOption === 'Frigorifique') {
			const otherOption =
				selectedOption === 'Bachée' ? 'Frigorifique' : 'Bachée'
			const otherOptionCheckbox = document.querySelector(
				`[value="${otherOption}"]`
			)
			if (otherOptionCheckbox) {
				otherOptionCheckbox.checked = false
			}
		}
	}
	const { t } = useTranslation()
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<FormContentSection>
			<HeaderContainer>
				<HeaderInfo>
					<FormSectionTitle>{t("vehicles")}</FormSectionTitle>
					<span>
						{t("vehicles_p")}
					</span>
				</HeaderInfo>
				{!disableAdd && (
					<AddVehicleButton
						type='button'
						onClick={(e) => {
							setModalIsOpen(true)
							e.stopPropagation()
						}}
					>
						{t("add_vehicle")}
					</AddVehicleButton>
				)}
			</HeaderContainer>
			{vehicles.length !== 0 && <FormSectionCard style={isSmallScreen ? { padding: '1rem' } : {}}>

				{isSmallScreen ?
					vehicles.map((v, index) => {
						return <div style={{
							width: '100%',
							background: '#F8FAFC',
							display: 'flex',
							flexDirection: 'column',
							padding: '1rem',
							borderRadius: 10,
							alignItems: 'flex-start',
							marginBottom: "1rem",
						}}>
							<div style={{
								fontWeight: 'bolder',
								color: '#1C63C5',
								fontSize: '1.2rem',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								marginBottom: '1rem',
								width: '100%'
							}}>
								<span>{t("vehicles")}{' '}{index + 1}</span>
								<div style={{ display: 'flex', gap: '5px' }}>
									<div
										onClick={() => handleEdit(index)}
										style={{
											cursor: 'pointer',
											marginRight: '10px',
										}}
									>
										<BiEdit
											size={24}
											style={{ color: '#51C7F2' }}
										/>
									</div>
									<div
										onClick={() => handleDelete(index)}
										style={{ cursor: 'pointer' }}
									>
										<MdDelete
											size={24}
											style={{ color: '#d9534f' }}
										/>
									</div>
								</div>
							</div>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}>
								{t("add_vehicle_column1")}:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}>{v?.type === 'Poids lourds' &&
									Array.isArray(v?.vehicule_poids_lourds)
									? v?.vehicule_poids_lourds?.join(
										', '
									)
									: v?.vehicule_poids_lourds}
									{v?.type === 'Véhicule léger' &&
										v?.vehicule_leger}</span>
							</span>
							<span style={{
								color: '#838EAB',
								fontSize: '0.9rem',
								marginBottom: '0.8rem',
							}}>
								Options:{' '}
								<span style={{
									fontSize: '0.9rem',
									fontWeight: 'bolder',
									color: '#838EAB',
								}}>{v?.type === 'Poids lourds' &&
									Array.isArray(v?.options_poids_lourds)
									? v?.options_poids_lourds?.join(
										', '
									)
									: v?.options_poids_lourds}
									{v?.type === 'Véhicule léger' &&
										Array.isArray(v?.options_vehicule_leger)
										? v?.options_vehicule_leger?.join(
											', '
										)
										: v?.options_vehicule_leger}</span>
							</span>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}
							>{t("add_vehicle_column3")}:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}>{v.date_mise_circulation}</span>
							</span>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}
							>{t("add_vehicle_column4")}:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}>{v.immatriculation}</span>
							</span>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}
							>{t("add_vehicle_column5")}:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}>{v?.location ? t("yes") : t("no")}</span>
							</span>
							<span style={{
								color: '#838EAB',
								marginBottom: '0.8rem',
								fontSize: '0.9rem',
							}}
							>{t("add_vehicle_column6")}:{' '}
								<span style={{
									color: '#838EAB',
									fontWeight: 'bolder',
									fontSize: '0.9rem'
								}}><span
									style={{
										cursor: v?.carte_grise?.path
											? 'pointer'
											: 'default',
										overflow: 'hidden',
										overflowWrap: 'anywhere',
										whiteSpace: 'normal'
									}}
									onClick={() => {
										if (v?.carte_grise?.path) {
											window.open(
												fileUrls[
												`carte_grise_${v._id}`
												]
											)
										}
									}}
								>
										{v?.carte_grise?.name ||
											t("no_document")}
									</span></span>
							</span>

						</div>
					}) :
					<TableContainer>
						<ResponsiveTable cellPadding={0} cellSpacing={0}>
							<thead>
								<tr>
									<th> {t("add_vehicle_column1")} </th>
									<th>Options</th>
									<th>{t("add_vehicle_column3")}</th>
									<th>{t("add_vehicle_column4")}</th>
									<th>{t("add_vehicle_column5")}</th>
									<th>{t("add_vehicle_column6")}</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								{vehicles.map((v, index) => (
									<tr key={String(index)}>
										<td>
											{v?.type === 'Poids lourds' &&
												Array.isArray(v?.vehicule_poids_lourds)
												? v?.vehicule_poids_lourds?.join(
													', '
												)
												: v?.vehicule_poids_lourds}
											{v?.type === 'Véhicule léger' &&
												v?.vehicule_leger}
										</td>
										<td>
											{v?.type === 'Poids lourds' &&
												Array.isArray(v?.options_poids_lourds)
												? v?.options_poids_lourds?.join(
													', '
												)
												: v?.options_poids_lourds}
											{v?.type === 'Véhicule léger' &&
												Array.isArray(v?.options_vehicule_leger)
												? v?.options_vehicule_leger?.join(
													', '
												)
												: v?.options_vehicule_leger}
										</td>
										<td>{v.date_mise_circulation}</td>
										<td>{v.immatriculation}</td>
										<td>{v?.location ? t("yes") : t("no")}</td>
										<td>
											<span
												style={{
													cursor: v?.carte_grise?.path
														? 'pointer'
														: 'default',
												}}
												onClick={() => {
													if (v?.carte_grise?.path) {
														window.open(
															fileUrls[
															`carte_grise_${v._id}`
															]
														)
													}
												}}
											>
												{v?.carte_grise?.name ||
													t("no_document")}
											</span>
										</td>
										<td
											style={{
												display: 'flex',
												flexDirection: 'row',
											}}
										>
											<div
												onClick={() => handleEdit(index)}
												style={{
													cursor: 'pointer',
													marginRight: '10px',
												}}
											>
												<BiEdit
													size={24}
													style={{ color: '#51C7F2' }}
												/>
											</div>
											<div
												onClick={() => handleDelete(index)}
												style={{ cursor: 'pointer' }}
											>
												<MdDelete
													size={24}
													style={{ color: '#d9534f' }}
												/>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</ResponsiveTable>
					</TableContainer>}
			</FormSectionCard>}

			<Modal
				isOpen={modalIsOpen}
				style={{
					overlay: {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.45)',
						zIndex: 1000,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						padding: '16px',
					},
					content: {
						position: 'relative',
						inset: 'auto', // Reset all positioning
						borderRadius: '19px',
						background: '#E4EAF0',
						padding: '32px',
						maxHeight: '90vh',
						maxWidth: '800px',
						zIndex: 1001,
						overflowY: 'auto',
						width: isSmallScreen? '100%' : '70%',
						
					},
				}}
				contentLabel='Ajouter un véhicule'
				portalClassName='modal-portal'
			>
				<ModalContent>
					<ModalTitle>
						{editIndex !== null
							? t("edit_vehicle")
							: t("add_vehicle")}
					</ModalTitle>

					<form onSubmit={handleSubmit(handleSubmitForm)}>
						{/* Type de véhicules */}
						<div style={{ marginBottom: '1.5rem' }}>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
									display: 'block',
								}}
							>
								{t("vehicle_type")} {' '}
								<span style={{ color: 'red' }}>*</span>
							</span>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
								}}
							>
								{Object.values(VEHICLE_TYPES).map(
									(vehicleType) => (
										<div
											key={vehicleType}
											style={{
												display: 'flex',
												alignItems: 'center',
												marginRight: '2rem',
												marginBottom: '1rem',
											}}
										>
											<input
												type='radio'
												style={{ marginRight: '16px' }}
												{...register('type', {
													required: true,
												})}
												value={vehicleType}
											/>
											<span>{vehicleType === VEHICLE_TYPES.HEAVY ? t("vehicle_type1") : t("vehicle_type2")}</span>
											<img
												src={IMAGES[vehicleType]}
												alt={vehicleType}
												style={{
													width: 40,
													marginLeft: '16px',
												}}
											/>
										</div>
									)
								)}
							</div>
							{errors.type && (
								<div
									style={{ color: 'red', marginTop: '.5rem' }}
								>
									{t("select_vehicle_type_err1")}
								</div>
							)}
						</div>

						{/* Vehicle Selection */}
						{type === VEHICLE_TYPES.LIGHT && (
							<FormGrid>
								{LIGHT_VEHICLES.map((vehicle) => (
									<VehicleCard
										key={vehicle.id}
										vehicle={vehicle}
										selected={
											watch('vehicule_leger') ===
											vehicle.name
										}
										onSelect={() =>
											setValue(
												'vehicule_leger',
												vehicle.name
											)
										}
										register={register}
										name='vehicule_leger'
									/>
								))}
								{errors.vehicule_leger && (
									<div style={{ color: 'red' }}>
										{t("select_vehicle_type_err2")}
									</div>
								)}
							</FormGrid>
						)}
						{type === VEHICLE_TYPES.HEAVY && (
							<FormGrid>
								{HEAVY_VEHICLES.map((vehicle) => (
									<VehicleCard
										key={vehicle.id}
										vehicle={vehicle}
										selected={
											watch('vehicule_poids_lourds') ===
											vehicle.name
										}
										onSelect={() =>
											setValue(
												'vehicule_poids_lourds',
												vehicle.name
											)
										}
										register={register}
										name='vehicule_poids_lourds'
									/>
								))}
								{errors.vehicule_poids_lourds && (
									<div style={{ color: 'red' }}>
										{t("select_vehicle_type_err2")}
									</div>
								)}
							</FormGrid>
						)}

						{/* Vehicle Options */}
						{type && (
							<div>
								<VehicleOptions
									title={`Options ${type === VEHICLE_TYPES.LIGHT ? 'véhicule léger' : 'poids lourds'}`}
									options={getVehicleOptions()}
									register={register}
									name={
										type === VEHICLE_TYPES.LIGHT
											? 'options_vehicule_leger'
											: 'options_poids_lourds'
									}
									required={true}
									onOptionChange={handleOptionChange}
								/>
								{(errors.options_vehicule_leger ||
									errors?.options_poids_lourds) && (
										<div style={{ color: 'red' }}>
											{errors?.options_poids_lourds
												?.message ||
												errors?.options_vehicule_leger
													?.message}
										</div>
									)}
							</div>
						)}

						{/* Date de mise en circulation */}
						<div style={{ marginBottom: '1.5rem'}}>
							<span
								style={{
									marginBottom: '1rem',
									marginTop: '1rem',
									color: 'black',
									fontSize: 14,
									display: 'block',
									 width :'100%' 
								}}
							>
								{t("add_vehicle_column3")}{' '}
								<span style={{ color: 'red' }}>*</span>
							</span>
							<Controller
								name='date_mise_circulation'
								control={control}
								defaultValue={null}
								rules={{
									required: t("add_vehicle_column3_err"),
								}}
								render={({ field }) => (
									<Flatpickr
										{...field}
										className='date-input'
										style={{
											width: '100%',
											padding: '10px',
											borderRadius: '5px',
											border: '1px solid #ccc',
										}}
										options={{
											mode: 'single',
											locale: French,
											dateFormat: 'd/m/Y',
											maxDate: new Date(),
										}}
										onChange={([date]) => {
											const formattedDate =
												moment(date).format(
													'DD/MM/YYYY'
												)
											field.onChange(formattedDate)
										}}
										ref={(ref) => field.ref(ref?.input)}
									/>
								)}
							/>
							{errors?.date_mise_circulation && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{errors?.date_mise_circulation?.message}
								</div>
							)}
						</div>

						{/* Immatriculation */}
						<div style={{ marginBottom: '1.5rem', }}>
							<span
								style={{
									marginBottom: '1rem',
									color: 'black',
									fontSize: 14,
									display: 'block',
								}}
							>
								{t("add_vehicle_column4")} {' '}
								<span style={{ color: 'red' }}>*</span>
							</span>
							<CustomInput
							style={{width: isSmallScreen ?'100%': ''}}
								type='text'
								placeholder='Ex: AA-123-AA ou 1234 ABC'
								{...register('immatriculation', {
									required: t("add_vehicle_column4_err1"),
									pattern: {
										value: /^[A-Z0-9\- ]{5,12}$/,
										message: t("add_vehicle_column4_err2"),
									},
								})}
							/>
							{errors?.immatriculation && (
								<div
									style={{
										color: 'red',
										marginTop: '0.5rem',
									}}
								>
									{errors?.immatriculation?.message}
								</div>
							)}
						</div>

						{/* Location */}
						<div
							style={{
								marginBottom: '1.5rem',
								display: 'flex',
								alignItems: 'center',
								fontSize: '14px',
							}}
						>
							<input
								type='checkbox'
								style={{ marginRight: '1rem' }}
								{...register('location')}
							/>
							<span>{t("rental_vehicle")}</span>
						</div>

						{/* Carte grise */}
						{!watch('location') && (
							<div style={{ marginBottom: '1rem' }}>
								<span
									style={{
										marginBottom: '1rem',
										color: 'black',
										fontSize: 14,
										display: 'block',
									}}
								>
									{t("add_vehicle_column6")} (PDF)
								</span>
								<Controller
									name='carte_grise'
									control={control}
									rules={{
										required: !watch('location')
											? t("add_vehicle_column6_err")
											: false,
									}}
									render={({ field }) => (
										<>
											<UploadFile
												name={field.name}
												accept={'.pdf'}
												setValue={setValue}
												{...field}
											/>
											{watch('carte_grise')?.name && (
												<span
													style={{
														marginTop: '0.5rem',
														fontSize: '14px',
														display: 'block',
														overflow: 'hidden',
														overflowWrap : 'anywhere'
													}}
												>
													{t("selected_file")}:{' '}
													{watch('carte_grise').name}
												</span>
											)}
											{errors?.carte_grise && (
												<span
													style={{
														color: 'red',
														fontSize: '14px',
														marginTop: '0.5rem',
														display: 'block',
													}}
												>
													{errors.carte_grise.message}
												</span>
											)}
										</>
									)}
								/>
							</div>
						)}

						{/* Action Buttons */}
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								flexDirection : isSmallScreen? 'column' : 'row',
								marginTop: '2rem',
								gap: isSmallScreen ? '1rem' : 0
							}}
						>
							<button
								type='button'
								onClick={handleSubmit(handleSubmitForm)}
								style={{
									background: '#50F5A9',
									width: isSmallScreen ? '100%' :'150px',
									height: '50px',
									border: 'none',
									cursor: 'pointer',
									color: 'white',
									borderRadius: 7,
									fontFamily: 'Montserrat',
									marginRight: 10,
									fontWeight: 'bold',
								}}
							>
								{editIndex !== null ? t("edit") : t("add")}
							</button>
							<button
								type='button'
								onClick={() => {
									setEditIndex(null)
									reset({
										type: '',
										date_mise_circulation: '',
										immatriculation: '',
										carte_grise: null,
										location: false,
									})
									setModalIsOpen(false)
								}}
								style={{
									width: isSmallScreen ? '100%' :'150px',
									height: '50px',
									background: 'red',
									border: 'none',
									cursor: 'pointer',
									color: 'white',
									borderRadius: 7,
									fontFamily: 'Montserrat',
									fontWeight: 'bold',
								}}
							>
								{t("cancel")}
							</button>
						</div>
					</form>
				</ModalContent>
			</Modal>
		</FormContentSection>
	)
}

export default AddVehicleRegister
